<template>
  <v-menu :close-on-content-click="false" max-width="320" offset-x>
    <template v-slot:activator="{ on }">
      <FilterBottom v-on="on" />
      <!-- <v-btn v-on="on" text>
        <v-icon class="mr-2">mdi-tune-variant</v-icon>
        Filtro
      </v-btn> -->
    </template>

    <v-card>
      <v-container>
        <v-switch
          v-model="filters.situacao"
          true-value="S"
          false-value="N"
          :label="`${filters.situacao == 'S' ? 'Ativo' : 'Inativo'}`"
          @change="handleFilter()"
        ></v-switch>
        <BaseFilter
          prepend-inner-icon="mdi-file-table-box-multiple-outline"
          clearable
          single-line
          label="Segmento"
          item-text="descricao"
          item-value="id_band"
          service="sistemaService.tipoBandeiras"
          v-model="filters.id_band"
          :filters="{ id_band: '2,4' }"
          :isCompany="true"
          @change="handleFilter()"
        />

        <BaseFilter
          prepend-inner-icon="mdi-account"
          clearable
          single-line
          label="Função"
          item-text="descricao"
          item-value="id_funcao"
          service="sistemaService.funcoes"
          :filters="{ id_band: filters.id_band, ativo: 'S' }"
          v-model="filters.id_funcao"
          :hasCode="true"
          @change="handleFilter()"
        />

        <v-autocomplete
          label="Tipo Evento"
          v-model="filters.id_classe_comissao"
          prepend-inner-icon="mdi-currency-usd"
          chips
          :items="[
            { text: 'Bônus', value: 'B' },
            { text: 'Comissão', value: 'C' },
            { text: 'Salário', value: 'S' }
          ]"
          :multiple="false"
          @change="handleFilter()"
        >
        </v-autocomplete>

        <BaseFilter
          label="Departamento"
          v-model="filters.id_depto"
          service="comissaoService.departamentos"
          item-text="departamento"
          item-value="id_depto"
          single-line
          prepend-inner-icon="mdi-toolbox"
          clearable
          :multiple="false"
          @change="handleFilter()"
        />
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import FilterBottom from "@/components/shared/bottons/FilterBottom";
import BaseFilter from "@/components/shared/BaseSelectService";
export default {
  name: "FilterComissao",

  components: {
    BaseFilter,
    FilterBottom
  },

  data() {
    return {
      filters: {
        situacao: "S"
      }
    };
  },

  methods: {
    handleFilter() {
      this.$emit("selectedFilters", this.filters);
    }
  }
};
</script>
<style scoped></style>
